exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header--3uXie{position:relative;padding-left:6px}.header--3uXie img{height:35px}", "", {"version":3,"sources":["/workspace/src/widget/header/style.scss"],"names":[],"mappings":"AAAA,eACE,kBAAkB,AAClB,gBAAiB,CAIlB,AAND,mBAII,WAAY,CACb","file":"style.scss","sourcesContent":[".header {\n  position: relative;\n  padding-left: 6px;\n  img {\n    height: 35px;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "header--3uXie"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/widget/header/style.scss
// module id = 1399
// module chunks = 0